module.exports = __webpack_public_path__ + "static/img/coreTechnology_6.875b380.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/coreTechnology_6.jpg
// module id = damy
// module chunks = 0